import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AddableExamination, AddExamComponent, AddExamDialogData } from './add-exam.component';
import { GridSelectionModel, IReportWorkflowExamService, Json, REPORT_WORKFLOW_EXAM_SERVICE_TOKEN } from '@se/platform';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { Action } from '@ngrx/store';

export interface AddExaminationOptions {
    enableSearch?: boolean;
    selectionModel?: GridSelectionModel;
}

@Injectable({
    providedIn: 'root',
})
export class AddExamService {
    constructor(
        private dialog: MatDialog,
        private injector: Injector,
        private translate: TranslateService,
    ) {}

    addExamination(
        examService: IReportWorkflowExamService,
        examination: AddableExamination,
        options?: AddExaminationOptions,
    ) {
        const data: AddExamDialogData = {
            header: this.buildHeader(examination),
            examination,
            enableSearch: options?.enableSearch ?? true,
            selectionModel: options?.selectionModel ?? GridSelectionModel.single,
        };

        const injector = Injector.create({
            parent: this.injector,
            providers: [
                {
                    provide: REPORT_WORKFLOW_EXAM_SERVICE_TOKEN,
                    useValue: examService,
                },
            ],
        });

        return this.dialog.open(AddExamComponent, { data, injector }).afterClosed();
    }

    private buildHeader(examination: AddableExamination) {
        return (
            this.translate.instant('TitleAddExam') +
            ' - ' +
            (examination?.patient.lastName || '').toUpperCase() +
            ' ' +
            (examination?.patient.firstName || '').toUpperCase() +
            ' - ' +
            examination?.exam.description
        );
    }

    addExaminationFromCp(
        examService: IReportWorkflowExamService,
        examination: AddableExamination,
        status: boolean,
        fnSave: () => Observable<({ model: Json } & Action<'[Cp] SetModel'>) | Action>,
        options?: AddExaminationOptions,
    ) {
        const data: AddExamDialogData = {
            header: this.buildHeader(examination),
            examination,
            enableSearch: options?.enableSearch ?? true,
            selectionModel: options?.selectionModel ?? GridSelectionModel.single,
            status: status,
            fnSave: fnSave,
        };

        const injector = Injector.create({
            parent: this.injector,
            providers: [
                {
                    provide: REPORT_WORKFLOW_EXAM_SERVICE_TOKEN,
                    useValue: examService,
                },
            ],
        });

        return this.dialog.open(AddExamComponent, { data, injector }).afterClosed();
    }
}
